import { list } from './list'
import { listDestinationUrls } from './listDestinationUrls'

export default {
  ...list,
  ...listDestinationUrls
}
